// extracted by mini-css-extract-plugin
export default {"main":"PricingSection_main__qGjzC","header":"PricingSection_header__jnnE+","removeBut":"PricingSection_removeBut__ZL-GY"};